import React from 'react';
import classNames from 'classnames';

import styles from './Icons.css';
import Loader from '../../../public/svg/LoaderIcon.svg';

export const LoaderIcon = React.memo((props: any) => (
    <Loader className={classNames(styles.loaderIcon, props.className)} aria-hidden="true" />
));
